import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ManageBoxesIcon from '@mui/icons-material/Dns';
import ManagePatientsIcon from '@mui/icons-material/SupervisorAccount';
import ManageUsersIcon from '@mui/icons-material/AccountBox';
import ManageAccountsIcon from '@mui/icons-material/AccountBalance';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Link, Location } from "@reach/router";
import USER_ROLES from '../common/userroles';
import ConsoleIcon from '@mui/icons-material/IndeterminateCheckBox';
import Report from './Report';
import { Divider } from '@mui/material';
// import EventIcon from '@mui/icons-material/Event';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { withTranslation } from 'react-i18next';
import GroupsIcon from '@mui/icons-material/Groups';
import AttributionIcon from '@mui/icons-material/Attribution';
import MapIcon from '@mui/icons-material/Map';
import PaymentIcon from '@mui/icons-material/Payment';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ViewListIcon from '@mui/icons-material/ViewList';
import { navActiveStyles, isNavPathActive } from './navActiveStyles';

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
    ...navActiveStyles,
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 2,
    '& .MuiListItemText-root': {
      overflow: 'visible',
      wordWrap: 'break-word',
    },
    '& .MuiListItemText-primary': {
      overflow: 'visible',
      wordWrap: 'break-word',
    },
    '& .MuiListItemText-secondary': {
      overflow: 'visible',
      wordWrap: 'break-word',
      whiteSpace: 'normal',
    },
  },
  textColor:{
    color: 'black',
  },
  listItem:{
    '&.MuiButtonBase-root': {
      display: 'flex',
      padding: '8px 24px 8px 24px'
    }
  },
  navLink: {
    textDecoration: 'none',
    display: 'block',
    color: 'inherit',
  },
});

class MenuList extends React.Component {
  state = {
    open: false,
    rolepermissionmenu: false,
    DeliveryTech: false,
    DeliveryTechReports: true,
    notification: false,
    helpToursOpen: false,
  };
  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };
  handleHelpToursClick = () => {
    this.setState(state => ({ helpToursOpen: !state.helpToursOpen }));
  };
  handleCompleteTour = () => {
    console.log('[Managemenulink] Complete Tour clicked from collapsible menu');
    if (this.props.onStartTour) {
      this.props.onStartTour();
    }
  };
  componentDidMount() {
    let role = JSON.parse(sessionStorage.getItem('superadmin'));
    if (role === USER_ROLES.SUPERADMIN) {
      this.setState({ rolepermissionmenu: true, notification: true });
    }
    let permissionUser = JSON.parse(sessionStorage.getItem('permissionUser'));
    if (permissionUser === USER_ROLES.DELIVERYTECH) {
      this.setState({ DeliveryTech: true })
    }
  }
  componentWillUnmount() {
    this.setState({ notification: false });
  }

  render() {
    const { classes, t, hasCounterLocations } = this.props;
    const currentLang = localStorage.getItem('i18nextLng');
    const _isRetail = localStorage.getItem('isRetail');
    return (
      <Location>
        {({ location }) => (
      <div id='react-no-print' className={classes.root}>
        {this.state.DeliveryTech ? (
          <div>
            <Link to="/home/manage/console" className={classes.navLink}>
              <ListItemButton
                className={classes.listItem}
                selected={isNavPathActive(location.pathname, '/home/manage/console')}
              >
                <ListItemIcon>
                  <ConsoleIcon />
                </ListItemIcon>
                <ListItemText primary={t("Leftbar.Console")} className={classes.textColor}/>
              </ListItemButton>
            </Link>
            <Divider />
            <Report />
            {/* Help & Tours menu item for DeliveryTech */}
            <Divider style={{ margin: '8px 0' }} />
            <ListItemButton 
              onClick={this.handleHelpToursClick}
              className={classes.listItem}
              data-tour="help-tours-menu"
            >
              <ListItemIcon>
                <HelpOutlineIcon />
              </ListItemIcon>
              <ListItemText primary={t("Leftbar.HelpAndTours")} className={classes.textColor} />
              {this.state.helpToursOpen ? <ExpandLess className={classes.textColor} /> : <ExpandMore className={classes.textColor} />}
            </ListItemButton>
            <Collapse in={this.state.helpToursOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  className={classes.nested}
                  onClick={this.handleCompleteTour}
                >
                  <ListItemIcon style={{ minWidth: 40 }}>
                    <PlayArrowIcon style={{ color: '#00a7e1', fontSize: 20 }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("Tour.CompleteTour") || "Complete Tour"}
                    secondary={t("Tour.CompleteTourDescription") || "All new features in 2 minutes"}
                    primaryTypographyProps={{
                      style: { fontSize: 14, fontWeight: 500, lineHeight: 1.4 },
                    }}
                    secondaryTypographyProps={{
                      style: { 
                        fontSize: 12, 
                        lineHeight: 1.4,
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                        whiteSpace: 'normal',
                      },
                    }}
                    className={classes.textColor}
                  />
                </ListItemButton>
                <ListItemButton
                  className={classes.nested}
                  onClick={this.handleCompleteTour}
                >
                  <ListItemIcon style={{ minWidth: 40 }}>
                    <ViewListIcon style={{ color: '#ff9800', fontSize: 20 }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("Tour.PaginationTitle") || "Enhanced Kiosk Pagination"}
                    secondary={t("Tour.PaginationContent") || "Navigate easily through the kiosk extensions"}
                    primaryTypographyProps={{
                      style: { fontSize: 14, fontWeight: 500, lineHeight: 1.4 },
                    }}
                    secondaryTypographyProps={{
                      style: { 
                        fontSize: 12, 
                        lineHeight: 1.4,
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                        whiteSpace: 'normal',
                      },
                    }}
                    className={classes.textColor}
                  />
                </ListItemButton>
              </List>
            </Collapse>
          </div>
        )
          :
          (
            <div>
              <Link to="/home/manage/locations" className={classes.navLink}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <ManageBoxesIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Leftbar.ManageLocation")} className={classes.textColor}/>
                </ListItemButton>
              </Link>
              {hasCounterLocations && (
                <Link to="/home/manage/locations/bin-mapping" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <MapIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.BinMapping")} className={classes.textColor}/>
                  </ListItemButton>
                </Link>
              )}
              <Link to={[false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) ? "/home/manage/patients" : "/home/manage/customers"} className={classes.navLink}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <ManagePatientsIcon />
                  </ListItemIcon>
                  <ListItemText primary={ [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) ? t("Leftbar.ManagePatient") : t("Leftbar.ManageCustomers") } className={classes.textColor}/>
                </ListItemButton>
              </Link>
              <Link tag="a" to="/home/manage/users/0" className={classes.navLink}>
                <ListItemButton onClick={this.handleClick} className={classes.listItem}>
                  <ListItemIcon>
                    <ManageUsersIcon />
                  </ListItemIcon>
                  <ListItemText inset primary={t("Leftbar.ManageUsers")} className={classes.textColor} style={{paddingLeft:'0px'}}/>
                  {this.state.rolepermissionmenu === true ? (this.state.open ? (<ExpandLess className={classes.textColor}/>) : (<ExpandMore className={classes.textColor}/>)) : ('')}
                </ListItemButton>
                {this.state.rolepermissionmenu === true ? (
                  <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton
                        className={classes.listItem}
                        component={Link}
                        to="/home/user-role/rolepermissions"
                        selected={isNavPathActive(location.pathname, '/home/user-role/rolepermissions')}
                      >
                        <ListItemText
                          inset
                          primary={t("Leftbar.RolePermissions")}
                          className={classes.textColor}
                        />
                      </ListItemButton>

                      <ListItemButton
                        className={classes.listItem}
                        component={Link}
                        to="/home/user-role/pushPermissions"
                        selected={isNavPathActive(location.pathname, '/home/user-role/pushPermissions')}
                      >
                        <ListItemText
                          inset
                          primary={t("Leftbar.PushPermission")}
                          className={classes.textColor}
                        />
                      </ListItemButton>
                    </List>
                  </Collapse>) : ('')}
              </Link>
              {
                JSON.parse(localStorage.getItem('isIlocalUser')) &&  [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) ? (
                  <Link tag="a" to="/home/manage/vendors" className={classes.navLink}>
                    <ListItemButton className={classes.listItem}>
                      <ListItemIcon>
                        <ManageUsersIcon />
                      </ListItemIcon>
                      <ListItemText inset primary={t("Leftbar.ManageVendors")} className={classes.textColor} style={{ paddingLeft: '0px' }} />
                    </ListItemButton>
                  </Link>
                ) : null
              }
              <Link to="/home/manage/groups" className={classes.navLink}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <GroupsIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Groups.ManageGroupsTitle")} className={classes.textColor}/>
                </ListItemButton>
              </Link>
              <Link to="/home/manage/roles" className={classes.navLink}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <AttributionIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Roles.ManageRolesTitle")} className={classes.textColor}/>
                </ListItemButton>
              </Link>
              <Link to="/home/manage/accounts" className={classes.navLink}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <ManageAccountsIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Leftbar.ManageAccounts")} className={classes.textColor}/>
                </ListItemButton>
              </Link>
              {(currentLang === 'en' && [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail)) &&
                <Link to="/home/manage/console" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <ConsoleIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.Console")} className={classes.textColor} />
                  </ListItemButton>
                </Link>
              }
              {[false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) &&
                <Link to="/home/manage/releaseHistory" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <NotificationsIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.Announcement")} className={classes.textColor} />
                  </ListItemButton>
                </Link>
              }
              {(() => {
                try {
                  const isIlocalUserValue = localStorage.getItem('isIlocalUser');
                  // Only show if user is ilocalbox user - must be explicitly 'true' (string)
                  // localStorage.setItem stores booleans as strings, so false becomes 'false'
                  // Admin/SuperAdmin status is ignored - only ilocalbox users can see billing
                  const isIlocalUser = isIlocalUserValue === 'true';
                  return isIlocalUser;
                } catch (e) {
                  console.error('Error checking billing permissions:', e);
                  return false;
                }
              })() ? (
                <Link to="/home/billing" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <PaymentIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.Billing")} className={classes.textColor} />
                  </ListItemButton>
                </Link>
              ) : null}
              {/* Help & Tours menu item */}
              <Divider style={{ margin: '8px 0' }} />
              <ListItemButton 
                onClick={this.handleHelpToursClick}
                className={classes.listItem}
                data-tour="help-tours-menu"
              >
                <ListItemIcon>
                  <HelpOutlineIcon />
                </ListItemIcon>
                <ListItemText primary={t("Leftbar.HelpAndTours")} className={classes.textColor} />
                {this.state.helpToursOpen ? <ExpandLess className={classes.textColor} /> : <ExpandMore className={classes.textColor} />}
              </ListItemButton>
              <Collapse in={this.state.helpToursOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    className={classes.nested}
                    onClick={this.handleCompleteTour}
                  >
                    <ListItemIcon style={{ minWidth: 40 }}>
                      <PlayArrowIcon style={{ color: '#00a7e1', fontSize: 20 }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={t("Tour.CompleteTour") || "Complete Tour"}
                      secondary={t("Tour.CompleteTourDescription") || "All new features in 2 minutes"}
                      primaryTypographyProps={{
                        style: { fontSize: 14, fontWeight: 500, lineHeight: 1.4 },
                      }}
                      secondaryTypographyProps={{
                        style: { 
                          fontSize: 12, 
                          lineHeight: 1.4,
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          whiteSpace: 'normal',
                        },
                      }}
                      className={classes.textColor}
                      style={{ margin: 0, paddingRight: 8 }}
                    />
                  </ListItemButton>
                  <ListItemButton
                    className={classes.nested}
                    onClick={this.handleCompleteTour}
                  >
                    <ListItemIcon style={{ minWidth: 40 }}>
                      <ViewListIcon style={{ color: '#ff9800', fontSize: 20 }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={t("Tour.PaginationTitle") || "Enhanced Kiosk Pagination"}
                      secondary={t("Tour.PaginationContent") || "Navigate easily through the kiosk extensions"}
                      primaryTypographyProps={{
                        style: { fontSize: 14, fontWeight: 500, lineHeight: 1.4 },
                      }}
                      secondaryTypographyProps={{
                        style: { 
                          fontSize: 12, 
                          lineHeight: 1.4,
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          whiteSpace: 'normal',
                        },
                      }}
                      className={classes.textColor}
                      style={{ margin: 0, paddingRight: 8 }}
                    />
                  </ListItemButton>
                </List>
              </Collapse>
              {/* {(currentLang === 'en' && [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail)) &&
                <Link to="/home/manage/appointment" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <EventIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.Appointment")} className={classes.textColor} />
                  </ListItemButton>
                </Link>
              } */}
            </div>
          )
        }
      </div>
        )}
      </Location>
    );
  }
}

MenuList.propTypes = {
  classes: PropTypes.object.isRequired,
  onStartTour: PropTypes.func,
  hasCounterLocations: PropTypes.bool,
};

export default withStyles(styles)(withTranslation()(MenuList));



// WEBPACK FOOTER //
// ./src/components/leftnav/Managemenulink.js